const Stats = () => {
    return (
        <>
            <iframe src="https://p.datadoghq.com/sb/embed/93b1f43c-c3c9-11eb-a531-da7ad0900002-81f901782bb2cda8942c0a2f0ba521f4" title="Realtime Stats" width="1600" height="800"></iframe>
        </>
    );
}
export default Stats;
